import React, { useRef, useState, useEffect, ReactNode } from 'react';

interface ResizableSplitPaneProps {
  left: ReactNode;
  right: ReactNode;
  initialLeftWidth?: number;
  minLeft?: number;
  minRight?: number;
  style?: React.CSSProperties;
}

const ResizableSplitPane: React.FC<ResizableSplitPaneProps> = ({
  left,
  right,
  initialLeftWidth = 380,
  minLeft = 220,
  minRight = 350,
  style = {},
}) => {
  const [leftWidth, setLeftWidth] = useState(initialLeftWidth);
  const dragging = useRef(false);

  const onMouseDown = (e: React.MouseEvent) => {
    dragging.current = true;
    document.body.style.cursor = 'col-resize';
  };

  const onMouseMove = (e: MouseEvent) => {
    if (!dragging.current) return;
    const container = document.getElementById('split-pane-container');
    if (!container) return;
    const rect = container.getBoundingClientRect();
    let newLeft = e.clientX - rect.left;
    if (newLeft < minLeft) newLeft = minLeft;
    if (newLeft > rect.width - minRight) newLeft = rect.width - minRight;
    setLeftWidth(newLeft);
  };

  const onMouseUp = () => {
    dragging.current = false;
    document.body.style.cursor = '';
  };

  useEffect(() => {
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };
  });

  return (
    <div id="split-pane-container" style={{ display: 'flex', width: '100%', ...style }}>
      <div style={{ 
        width: leftWidth, 
        minWidth: minLeft, 
        transition: dragging.current ? 'none' : 'width 0.2s', 
        background: 'transparent' 
      }}>
        {left}
      </div>
      <div
        style={{ 
          width: 3, 
          cursor: 'col-resize', 
          background: '#ddd', 
          zIndex: 2 
        }}
        onMouseDown={onMouseDown}
      />
      <div style={{ 
        flex: 1, 
        minWidth: minRight, 
        background: 'transparent' 
      }}>
        {right}
      </div>
    </div>
  );
};

export default ResizableSplitPane; 